// extracted by mini-css-extract-plugin
export default {"header":"BackToPreviousPageHeader___styles-module__header___Fg2UK","nav":"BackToPreviousPageHeader___styles-module__nav___E2p1L"};